define("Ames.RentFromAnywhere.RentalOrder.History.View", [
  "tavano_ttrentalorders_rentalorders.tpl",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "Backbone",
  "Profile.Model",
  "Utils",
], function (
  rentalOrdersTpl,
  RentFromAnywhereSS2Model,
  Backbone,
  ProfileModel,
  Utils
) {
  "use strict";

  var FEDEX_TRACK_URL = "https://www.fedex.com/wtrk/track/?tracknumbers=";

  /**
   * Parse a comma-separated tracking string into individual numbers
   */
  function parseTrackingNumbers(str) {
    if (!str) return [];
    return str
      .split(",")
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  /**
   * Build enriched rental data for template consumption
   */
  function enrichRental(rental) {
    // ── Tracking ──
    var allTrackingNumbers = [];
    var seen = {};

    (rental.fulfillments || []).forEach(function (ff) {
      var nums = parseTrackingNumbers(ff.returnTrackingNumber);
      nums.forEach(function (num) {
        if (!seen[num]) {
          seen[num] = true;
          allTrackingNumbers.push({
            number: num,
            url: FEDEX_TRACK_URL + encodeURIComponent(num),
            fulfillTranid: ff.tranid,
          });
        }
      });

      (ff.returnLabels || []).forEach(function (label) {
        if (label.tracking && !seen[label.tracking]) {
          seen[label.tracking] = true;
          allTrackingNumbers.push({
            number: label.tracking,
            url: FEDEX_TRACK_URL + encodeURIComponent(label.tracking),
            fulfillTranid: ff.tranid,
            labelUrl: label.fileUrl || null,
            labelDate: label.date || null,
          });
        }
      });
    });

    rental.parsedTracking = allTrackingNumbers;
    rental.hasTracking = allTrackingNumbers.length > 0;
    rental.trackingCount = allTrackingNumbers.length;
    rental.singleTracking = allTrackingNumbers.length === 1 ? allTrackingNumbers[0] : null;

    // ── Due Dates ──
    var dueDates = [];
    (rental.lineDetails || []).forEach(function (line) {
      if (line.rentalEndDate) {
        dueDates.push({
          date: line.rentalEndDate,
          item: line.rentalItemText || "Item",
          unitNames: line.unitNames || "",
          rentalType: line.rentalType || "",
          quantity: line.quantity || "1",
        });
      }
    });

    rental.dueDates = dueDates;
    rental.hasDueDates = dueDates.length > 0;
    rental.dueDateCount = dueDates.length;
    rental.singleDueDate = dueDates.length === 1 ? dueDates[0] : null;
    rental.multipleDueDates = dueDates.length > 1;

    return rental;
  }

  return Backbone.View.extend({
    template: rentalOrdersTpl,

    events: {
      "mouseenter [data-toggle-popup]": "showPopup",
      "mouseleave [data-toggle-popup]": "hidePopup",
      "click [data-toggle-popup]": "togglePopupMobile",
      "click .rental-popup-overlay": "closeAllPopups",
      "click [data-page]": "goToPage",
    },

    initialize: function (options) {
      this.model = new RentFromAnywhereSS2Model();
      this.rentals = [];
      this.isLoading = true;
      this.currentPage = 1;
      this.totalPages = 1;
      this.totalRecords = 0;
      this.allRentalsActive =
        Utils.getParameterByName(window.location.href, "open-rentals-only") !== "true";
      this._openPopupId = null;
      this._hideTimeout = null;

      this.fetchPage(1);
    },

    fetchPage: function (page) {
      var self = this;
      this.isLoading = true;
      this.currentPage = page;
      this.render();

      this.model
        .fetch({
          data: {
            history: true,
            open_rentals_only: this.allRentalsActive ? "false" : "true",
            page: page,
            pageSize: 20,
          },
        })
        .done(function (data) {
          self.rentals = (data.rentals || []).map(enrichRental);

          var pagination = data.pagination || {};
          self.currentPage = pagination.page || 1;
          self.totalPages = pagination.totalPages || 1;
          self.totalRecords = pagination.totalRecords || 0;

          self.isLoading = false;
          self.render();
        })
        .fail(function () {
          self.rentals = [];
          self.isLoading = false;
          self.render();
        });
    },

    goToPage: function (e) {
      e.preventDefault();
      var page = parseInt(this.$(e.currentTarget).data("page"), 10);
      if (page && page !== this.currentPage && page >= 1 && page <= this.totalPages) {
        this.fetchPage(page);
        // Scroll to top of list
        this.$el[0].scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    getContext: function () {
      // Build page numbers array for template
      var pages = [];
      for (var i = 1; i <= this.totalPages; i++) {
        pages.push({
          number: i,
          isCurrent: i === this.currentPage,
        });
      }

      return {
        rentals: this.rentals,
        hasRentals: this.rentals && this.rentals.length > 0,
        allRentalsActive: this.allRentalsActive,
        isLoading: this.isLoading,
        // Pagination
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        totalRecords: this.totalRecords,
        showPagination: this.totalPages > 1 && !this.isLoading,
        hasPrevPage: this.currentPage > 1,
        hasNextPage: this.currentPage < this.totalPages,
        prevPage: this.currentPage - 1,
        nextPage: this.currentPage + 1,
        pages: pages,
      };
    },

    // ── Popup Handlers ──

    _isMobile: function () {
      return window.innerWidth <= 768;
    },

    showPopup: function (e) {
      if (this._isMobile()) return;
      var $trigger = this.$(e.currentTarget);
      var popupId = $trigger.data("toggle-popup");

      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }

      this.$(".rental-info-popup").not("#" + popupId).removeClass("is-visible");
      this.$("#" + popupId).addClass("is-visible");
    },

    hidePopup: function (e) {
      if (this._isMobile()) return;
      var $trigger = this.$(e.currentTarget);
      var popupId = $trigger.data("toggle-popup");
      var self = this;

      this._hideTimeout = setTimeout(function () {
        self.$("#" + popupId).removeClass("is-visible");
        self._hideTimeout = null;
      }, 100);
    },

    togglePopupMobile: function (e) {
      if (!this._isMobile()) return;
      e.preventDefault();
      e.stopPropagation();

      var $trigger = this.$(e.currentTarget);
      var popupId = $trigger.data("toggle-popup");
      var $popup = this.$("#" + popupId);
      var isOpen = $popup.hasClass("is-visible");

      this.$(".rental-info-popup").removeClass("is-visible");
      this.$(".rental-popup-overlay").remove();

      if (!isOpen) {
        $popup.addClass("is-visible");
        this._openPopupId = popupId;
        this.$el.append('<div class="rental-popup-overlay"></div>');
      } else {
        this._openPopupId = null;
      }
    },

    closeAllPopups: function () {
      this.$(".rental-info-popup").removeClass("is-visible");
      this.$(".rental-popup-overlay").remove();
      this._openPopupId = null;
    },
  });
});
